<template>
    <div class="user-info">
        <p class="info-txt">
            <span v-if="login && !kd" class="logout" @click="call_logout">【退出】</span>
            <span v-if="!login" class="login" @click="call_login">【登录】</span>

            <span class="player-name">{{ name|e }}</span>
            <span class="area-name">{{ queryArea(aid) }}</span>

            <span v-if="login && aid < 1" class="bind" @click="callAreaModal">【绑定大区】</span>
        </p>

        <div class="u-btn rule" @click="callRuleModal">活动规则</div>
        <rule-modal ref="rule"></rule-modal>
    </div>
</template>

<script>
import KD from '@/assets/js/kd.js';
import GLOBAL from '@/assets/js/global.js';
import mslogin from '@/assets/js/msLogin.js';
import ruleModal from '@/components/ruleModal.vue';

export default {
    name : 'user-info',
    data (){
        return {
            kd : KD.isApp(),
        }
    },
    props: {
        name: {
            type: String,
            default: '仙术师'
        },
        aid : {
            default: 0
        },
        login : {
            default: 0
        }
    },
    filters : {
        e(str) {return str || '仙术师'}
    },
    methods: {
        queryArea(num) {
            var area = '暂无大区信息';

            if (num == 1) {
                area = '火烧赤壁';
            } else if (num == 2) {
                area = '草船借箭';
            } else if (num == 6) {
                area = '荆州之战';
            } else if (num == 7) {
                area = '青梅煮酒';
            } else if (num == 8) {
                area = '官渡之战';
            } else if (num == 9) {
                area = '桃园结义';
            } else if (num == 11) {
                area = '九伐中原';
            } else if (num == 12) {
                area = '逐鹿中原';
            } else if (num == 13) {
                area = '三分天下';
            } else if (num == 16) {
                area = '怀旧服';
            }else if (num == 17) {
                area = '铜雀台';
            } else if (num == 18) {
                area = '凤仪亭';
            }else if (num == 19) {
                area = '火凤燎原';
            }else if (num == 20) {
                area = '卧龙出渊';
            }else if (num == 21) {
                area = '长生殿';
            }else if (num == 100) {
                area = '测试大区';
            }

            return area;
        },

        callRuleModal(){
            document.body.addEventListener('touchmove',GLOBAL.bodyScroll,{ passive: false });
            this.$refs.rule.ruleModal_trriger = true;
        },

        callAreaModal(){
            document.body.addEventListener('touchmove',GLOBAL.bodyScroll,{ passive: false });
            this.$emit("modal_switch", 'area_modal_trriger');
        },        

        call_login(){
            mslogin.open();
        },

        call_logout(){
            localStorage.setItem("token", "");
            setTimeout(function () {  
                location.reload();
            }, 100);            
        },
    },
    components : {
        'rule-modal' : ruleModal
    }       
}
</script>

<style>
    .user-info{
        display: flex;
        width: 7.07rem;
        height: .82rem;
        /* line-height: .82rem; */
        padding: 0 .2rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/bg-userinfo.png);
        color: #ffac73;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
    }

    .u-btn.rule{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/components/userInfo.vue